import { Component, OnInit, Input, OnDestroy, ViewChild, ElementRef } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { modelToFormGroup } from 'aautil';
import { Comment } from '@model/comment/comment';
import { CommentService } from '@service/comment/comment.service';
import { ToastService } from '@service/toast/toast.service';
import { UserService } from '@service/user/user.service';
import { tinyDefaultConfig } from '@configuration/tiny-default-config';
import { Entity } from '@model/entities/entity';
import { Subscription } from 'rxjs';
import { LoadingService } from '@service/loading.service';
import { ScrollService } from '@service/scroll.service';
import { DialogService } from '@service/dialog.service';

@Component({
  selector: 'comments',
  templateUrl: './comments.component.html',
  styleUrls: ['./comments.component.scss'],
})
export class CommentsComponent implements OnInit, OnDestroy {
  // blog / job / etc
  @Input() public entity: Entity;

  @ViewChild('commentsElementRef') set commentsElementRef(el: ElementRef) {
    this.ScrollService.commentsElementRef = el;
    this.ScrollService.commentsElementRefSet.emit();
  }

  @ViewChild('writeComment') set writeComment(el: ElementRef) {
    this.ScrollService.writeComment = el;
    this.ScrollService.writeCommentSet.emit();
  }

  public comments: Comment[] = [];
  public writing: boolean = false;
  public newComment: Comment = new Comment();

  public tinyDefaultConfig = tinyDefaultConfig;

  public form: FormGroup;

  // subscriptions
  private userSubscription: Subscription = null;
  private cDeletedSubscription: Subscription = null;

  constructor(
    private commentService: CommentService,
    private toastService: ToastService,
    public UserService: UserService,
    private loadingService: LoadingService,
    private ScrollService: ScrollService,
    public DialogService: DialogService,
  ) {}

  public ngOnInit() {
    // init new comment
    this.form = modelToFormGroup(this.newComment);

    // get comments only when loggedin
    // this.userSubscription = this.UserService.userObservable.subscribe(loggedIn => {
    //   if(loggedIn)
    this.getComments();
    // })

    // if a comment gets deleted -> remove it
    this.cDeletedSubscription = this.commentService.commentDeletedObservable.subscribe((id: number) => {
      this.comments = this.comments.filter((c) => c.id !== id);
      this.loadingService.stopLoad();
    });
  }

  public ngOnDestroy() {
    if (this.userSubscription) this.userSubscription.unsubscribe();
    if (this.cDeletedSubscription) this.cDeletedSubscription.unsubscribe();
  }

  public abortWriteComment() {
    this.writing = false;
    this.newComment = new Comment();
    this.form = modelToFormGroup(this.newComment);
  }

  public sendComment() {
    const commentText = this.form.value.message;

    this.loadingService.startLoad();

    return this.commentService
      .addComment(this.entity, commentText)
      .then((comment: Comment) => {
        this.writing = false;

        // render comment
        this.comments.push(comment);
        this.form.reset();
        setTimeout(() => {
          this.ScrollService.scrollToSelector('app-comment:last-child');
        }, 400);
      })
      .catch((err) => {
        this.toastService.showError('Es ist ein Fehler aufgetreten, bitte versuchen Sie es erneut.');
      })
      .finally(() => {
        this.loadingService.stopLoad();
      });
  }

  public getComments(): Promise<void> {
    return this.commentService.getComments(this.entity).then((comments: Comment[]) => {
      this.comments = comments.sort((a, b) => {
        return a.created_at > b.created_at ? 1 : -1;
      });
    });
  }

  public showLogginDialogIfNotLoggedIn() {
    if (!this.UserService.isLoggedIn) this.DialogService.loginRegistrationDialog('login', true);
  }

  public trackByFn(index, item) {
    return item.id;
  }
}
